import { render, staticRenderFns } from "./mini-setting.vue?vue&type=template&id=7de01dc6&scoped=true&"
import script from "./mini-setting.vue?vue&type=script&lang=ts&"
export * from "./mini-setting.vue?vue&type=script&lang=ts&"
import style0 from "./mini-setting.vue?vue&type=style&index=0&id=7de01dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de01dc6",
  null
  
)

export default component.exports